export const VatSectionData = {
    countries: [
      {
        country: "South Africa",
        section: "VAT",
        details: {
          general: {
            description: "The standard rate of VAT in South Africa is 15.00%.",
          },
        },
      },
      {
        country: "India",
        section: "VAT (GST)",
        details: {
          general: {
            description: "India applies a Goods and Services Tax (GST) with rates ranging from 0% to 28%, depending on the goods or services.",
          },
        },
      },
      {
        country: "United States",
        section: "Sales Tax",
        details: {
          general: {
            description: "The United States does not have a federal VAT. Sales tax rates vary by state and range from 0% to 10%.",
          },
        },
      },
    ],
  };
  